import "./component4.scss";
import React, { useEffect, useMemo, useState } from "react";
import slider_1 from "../../Images/slider/slider_1.jpg";
import slider_2 from "../../Images/slider/slider_2.jpg";
import slider_3 from "../../Images/slider/slider_3.jpg";
import slider_4 from "../../Images/slider/slider_4.jpg";
import slider_5 from "../../Images/slider/slider_5.jpg";
import slider_6 from "../../Images/slider/slider_6.jpg";
import slider_7 from "../../Images/slider/slider_7.jpg";
import slider_8 from "../../Images/slider/slider_8.jpg";
import descImage_3 from "../../Images/descImages/descImage_3.jpg";
import descImage_4 from "../../Images/descImages/descImage_4.jpg";
import descImage_6 from "../../Images/descImages/descImage_6.jpg";

const AUTO_MS = 5200;

const Component4 = () => {
  const slides = useMemo(
    () => [
      slider_1,
      slider_2,
      descImage_6,
      descImage_3,
      descImage_4,
      slider_3,
      slider_4,
      slider_5,
      slider_6,
      slider_7,
      slider_8,
    ],
    []
  );

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, AUTO_MS);
    return () => window.clearInterval(id);
  }, [slides.length]);

  const go = (delta: number) => {
    setIndex((i) => (i + delta + slides.length) % slides.length);
  };

  return (
    <section className="gallery component4" id="gallery">
      <div className="container">
        <p className="section-label gallery__label">Интерьер и атмосфера</p>
        <h2 className="gallery__title">
          Премиум-сервис, лаунж, кухня и бар — в одном пространстве
        </h2>
        <p className="gallery__subtitle">
          Большой выбор блюд и напитков, внимательный персонал и продуманный свет
          — чтобы вечер проходил ровно так, как вы задумали.
        </p>

        <div className="gallery__stage" aria-roledescription="carousel">
          <div className="gallery__viewport">
            {slides.map((slide, i) => (
              <figure
                key={`gallery-slide-${i}`}
                className={`gallery__slide${i === index ? " is-active" : ""}`}
                aria-hidden={i !== index}
              >
                <img src={slide} alt="" loading={i === 0 ? "eager" : "lazy"} />
              </figure>
            ))}
          </div>

          <button
            type="button"
            className="gallery__nav gallery__nav--prev"
            onClick={() => go(-1)}
            aria-label="Предыдущее фото"
          >
            ‹
          </button>
          <button
            type="button"
            className="gallery__nav gallery__nav--next"
            onClick={() => go(1)}
            aria-label="Следующее фото"
          >
            ›
          </button>

          <div className="gallery__dots" role="tablist">
            {slides.map((_, i) => (
              <button
                key={String(i)}
                type="button"
                role="tab"
                aria-selected={i === index}
                className={`gallery__dot${i === index ? " is-active" : ""}`}
                onClick={() => setIndex(i)}
                aria-label={`Слайд ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Component4;
